/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ArrowsDiagonal(props) {
  return (
    <Icon {...props}>
      <polygon points="21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71" />
    </Icon>
  )
}

ArrowsDiagonal.tags = ['Fullscreen']
ArrowsDiagonal.category = categories.actions

export default ArrowsDiagonal
